export const RouteGetMerchflowBasePog_basePogId_logs = "/merchflow/base-pog/:basePogId/logs";

export interface ResponseGetMerchflowBasePog_basePogId_logs {
  id: number;
  pogger_request_path: string | null;
  pogger_response_path: string | null;
  pm_data_path: string | null;
}
